import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-slate-900 py-16 md:py-24 overflow-hidden pt-[24px] pb-[24px]" data-id="element-80">
      {/* Background glow effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-81">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" data-id="element-82" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" data-id="element-83" />
      </div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-84">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-85">
          {/* Text Content */}
          <motion.div className="flex-1 text-center md:text-left" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-86">
            <h1 className="text-4xl md:text-6xl font-black mb-6 leading-tight" data-id="element-87">
              <span className="text-gold-gradient" data-id="element-88">MÉTODO "CAJA DE ORO"</span>
            </h1>

            <h2 className="text-xl md:text-2xl text-slate-200 font-medium mb-8 leading-relaxed" data-id="element-89">
          Sistema exacto para generar ingresos extra esta misma semana sin salir de casa
            </h2>

            <motion.a href="#offer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(245, 158, 11, 0.4)', '0 0 0 20px rgba(245, 158, 11, 0)']
          }} transition={{
            boxShadow: {
              duration: 1.5,
              repeat: Infinity
            }
          }} className="bg-gold-gradient text-slate-900 font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg flex items-center gap-2 mx-auto md:mx-0 cursor-pointer no-underline" data-id="element-90">
              ¡QUIERO EMPEZAR MI CAJA DE ORO AHORA!
              <ArrowRight className="w-6 h-6" data-id="element-91" />
            </motion.a>
          </motion.div>

          {/* Hero Image */}
          <motion.div className="flex-1 w-full max-w-md md:max-w-full" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-92">
            <div className="relative" data-id="element-93">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-400 to-amber-600 rounded-2xl blur opacity-30" data-id="element-94"></div>
              <img src="https://cdn.magicpatterns.com/uploads/8FQoMjFa1ntpi54p3AAZQC/heylloyd-image-1772074446810.jpg" alt="Método Caja de Oro Book Cover" className="relative rounded-2xl shadow-2xl w-full border border-slate-700" data-id="element-95" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}